import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanDeactivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { SessionService } from './session.service';
import { AppRouterService } from './app-router.service';
import { Observable } from 'rxjs';
import { NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root'
})
export class BaseAppRouteGuardService implements CanActivate, CanActivateChild, CanLoad {
  role = [];
  perm_mode = [];
  isLogin: boolean = false;
  
  constructor(private storage: Storage, private nav: NavController, private helperService:HelperService) { }


 async isLoggedIn() {
    const loggedIn = await this.storage.get('token');
    if (loggedIn){
      // const decoded = JSON.parse(atob(loggedIn.split('.')[1]));
      this.isLogin = true;
    }
    else{
      this.isLogin = false;
    }
    return this.isLogin;
  }

 async getRole(){
    const token = await this.storage.get('token');
    let decoded
    await this.helperService.decode(token).then((d)=>{decoded=d})
    return decoded;
  }

public async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const allowedUserRoles = this.getRoutePermissions(route);
    return await this.checkPermission(allowedUserRoles);
  }
  public async canActivateChild(route: ActivatedRouteSnapshot): Promise<boolean> {
    const allowedUserRoles = this.getRoutePermissions(route);
    return await this.checkPermission(allowedUserRoles);
  }
//   canDeactivate(
//     component: unknown,
//     currentRoute: ActivatedRouteSnapshot,
//     currentState: RouterStateSnapshot,
//     nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
//     return true;
//   }
  public canLoad(): Promise<boolean> {
    return this.checkPermission(null);
  }


  private getRoutePermissions(route: ActivatedRouteSnapshot) {
    if (route.data && route.data.Permission) {
      return route.data.Permission;
    }
    return null;
  }

  

  

//   checkUserLogin(route: ActivatedRouteSnapshot, url: any): boolean {
//     if (this.isLoggedIn()) {
//       this.getrole().then((res)=>{
//         this.role = res.role;
//       if (route.data.role && route.data.role.indexOf(this.role) === -1) {
//         this.nav.navigateRoot(['baseapp']);
//         return false;
//       }
//     }
//     );
//       return true;
//     }
//     this.nav.navigateRoot(['login']);
//     return false;
//   }

private checkPermission(allowedUserRoles): Promise<boolean> {
    return this.isLoggedIn().then((session: boolean) => {
      if (session) {
        if (!allowedUserRoles) {
          return true;   // if no user roles has been set, all user are allowed to access the route
        } 
        else {
          this.perm_mode=[];
          return this.getRole().then((userRoles) => {
            for (const obj of userRoles.permissions) {
              this.perm_mode.push((obj.perm_mod));
          }
            this.role = allowedUserRoles;
            if (this.perm_mode.includes(this.role)) {
              return true;
            } else {
              this.nav.navigateRoot(['baseapp/notauthorized']);
              return false;
            }
          });
        }
      } else { return false; }
    });
  }
}
